import { defineComponent as r, openBlock as t, createBlock as o, normalizeProps as a, guardReactiveProps as n, withCtx as p, renderSlot as h, createElementVNode as l } from "vue";
import m from "../CdrIcon.vue.mjs";
const s = /* @__PURE__ */ l("path", {
  role: "presentation",
  d: "M17.67 8.25c.6 0 1.08.488 1.087 1.08v7.597c0 .6-.487 1.08-1.08 1.08H5.58c-.593 0-1.08-.487-1.08-1.08V9.33c0-.592.487-1.08 1.08-1.08H9V7.125C9 6.503 9.502 6 10.125 6h3c.623 0 1.125.503 1.125 1.125V8.25h3.42zm-8.333 2.992L9 11.61v1.14h.75v-1.133l-.39-.367c-.008 0-.015-.008-.022-.008zM9 10.62V9H7.5v8.25h8.25V9h-6v1.62c.037.023.082.038.113.075l.45.428c.12.112.187.262.187.42v1.342c0 .338-.3.615-.675.615h-.9c-.375 0-.675-.277-.675-.615v-1.342c0-.158.068-.308.188-.428l.45-.428c.03-.03.075-.044.112-.067zm1.125-3.87a.376.376 0 00-.375.375V8.25h3.75V7.125a.376.376 0 00-.375-.375h-3zM5.25 16.92c0 .18.15.33.33.33h1.17V9H5.58c-.18 0-.33.15-.33.33v7.59zm12.75 0V9.33c0-.18-.15-.33-.33-.33H16.5v8.25h1.17c.18 0 .33-.15.33-.33zm-5.625-.233a.371.371 0 01-.375-.375v-1.5a.37.37 0 01.375-.374h2.25a.37.37 0 01.375.374v1.5c0 .21-.165.375-.375.375h-2.25zm.375-1.5v.75h1.5v-.75h-1.5zm1.125-1.687a1.123 1.123 0 01-1.125-1.125c0-.623.502-1.125 1.125-1.125S15 11.752 15 12.375s-.502 1.125-1.125 1.125zm0-1.5a.376.376 0 00-.375.375.376.376 0 00.75 0 .376.376 0 00-.375-.375z"
}, null, -1), d = /* @__PURE__ */ r({
  name: "ExperiencesTravel",
  __name: "experiences-travel",
  props: {
    props: {
      type: Object
    }
  },
  setup(e) {
    return (c, v) => (t(), o(m, a(n(e.props)), {
      default: p(() => [h(c.$slots, "default"), s]),
      _: 3
    }, 16));
  }
});
export {
  d as default
};
